import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, addData, updateData, getcountries, getseriesType } from '../../../services/event/abstractReceipt/abReviewersServices';
import { Modal, Button, Form } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
// import base_url from '../../../config';
import Spinner from '../../../components/Spinner';
import Swal from 'sweetalert2';
import { validateImageFile } from '../../../utils/fileValidation';

const subDomain = localStorage.getItem('sub_domain') || '';

const Abreviewers = () => {
const [dataList, setDataList] = useState([]);
const [form, setForm] = useState({ id: '', sub_domain: subDomain, series: '', reviewer_id: '', reviewer_name: '', reviewer_affiliation: '', reviewer_country: '', 
uploadedfile: null, status: false, approval: false
});
const [modalType, setModalType] = useState('');
const [showModal, setShowModal] = useState(false);
const [searchText, setSearchText] = useState('');
const [currentPage, setCurrentPage] = useState(1);
const [countries, setcountries] = useState([]);
const [loading, setLoading] = useState(true);
const [originalStatus, setOriginalStatus] = useState(false); // new state
const [errors, setErrors] = useState({});
const [seriesValue, setSeriesValue] = useState('');

// Fetch data list
const fetchData = useCallback(async () => {
    try {
      const data = await getData({sub_domain: subDomain });
      setDataList(data);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
}, []);

const fetchseriesType = useCallback(async () => {
  try {
    const data = await getseriesType({ sub_domain: subDomain });
    if (data && data.length > 0) {
      const seriesInfo = data[0];
      setSeriesValue(seriesInfo.series || '');
    }
  } catch (error) {
    console.error('Failed to fetch series info:', error);
  }
}, []);

   

useEffect(() => {
    const fetchDataAsync = async () => {
        setLoading(true); 
        await fetchData();
        await fetchseriesType();  
        // Optional 2 second delay
        await new Promise((resolve) => setTimeout(resolve, 1000));
        setLoading(false); 
      };
    
      fetchDataAsync();
}, [fetchData, fetchseriesType]);


  useEffect(() => {
    const fetchcountries = async () => {
      try {
        const data = await getcountries(); // Fetch data from the service
        setcountries(data); // Set the types in state
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchcountries();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
  
    // Handle file input separately
    if (files && files.length > 0) {
      const file = files[0];
  
      validateImageFile(file)
        .then(() => {
          setForm((prev) => ({
            ...prev,
            [name]: file,
          }));
          setErrors((prev) => ({ ...prev, uploadedfile: '' }));
        })
        .catch((err) => {
          setForm((prev) => ({
            ...prev,
            [name]: null,
          }));
          setErrors((prev) => ({ ...prev, uploadedfile: err }));
        });
      return;
    }
  
    // Define val properly
    let val = value;
    if (name === 'status') {
      val = value === '1'; // Convert string to boolean
    }
  
    setForm((prev) => ({
      ...prev,
      [name]: val,
    }));
  
    // Clear error for the field
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };
  

  const validateForm = () => {
    const newErrors = {};
    if (!form.uploadedfile && modalType === 'add') {
      newErrors.uploadedfile = 'Signature file is required';
    }
        
    if (!form.reviewer_name.trim()) newErrors.reviewer_name = 'Reviewer name is required';
    if (!form.reviewer_affiliation.trim()) newErrors.reviewer_affiliation = 'Reviewer affiliation is required';
    if (!form.reviewer_country.trim()) newErrors.reviewer_country = 'Country is required';
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
  const handleSubmit = async (e) => {
    if (!validateForm()) return;
    e.preventDefault();
  
    let updatedForm = { ...form };
  
    if (modalType === 'edit') {
      // // If status wasn't changed by user, and it's currently active, deactivate and reset approval
      // if (originalStatus === true && form.status === originalStatus) {
      //   updatedForm.status = false; // set to inactive
      //   updatedForm.approval = false; // reset approval
      // }
      if (updatedForm.status === true) {
      updatedForm.approval = false;
    }
    }
    const formData = new FormData();
    formData.append('id', updatedForm.id || '');
    formData.append('reviewer_id', updatedForm.reviewer_id || '');
    formData.append('sub_domain', updatedForm.sub_domain);
    formData.append('series', updatedForm.series);
    formData.append('reviewer_name', updatedForm.reviewer_name);
    formData.append('reviewer_affiliation', updatedForm.reviewer_affiliation);
    formData.append('reviewer_country', updatedForm.reviewer_country);
    formData.append('status', updatedForm.status ? 1 : 0);
    formData.append('approval', updatedForm.approval ? 1 : 0);
    if (updatedForm.uploadedfile) {
      formData.append('uploadedfile', updatedForm.uploadedfile);
    }
  
    try {
      if (modalType === 'add') {
        await addData(formData);
      } else if (modalType === 'edit') {
        await updateData(formData);
      }
      fetchData();
      setShowModal(false);
   // ✅ Show success alert with auto-close
         Swal.fire({
           icon: 'success',
           title: 'Success',
           text: `Reviewers ${modalType === 'add' ? 'added' : 'updated'} successfully!`,
           timer: 2000, // 2 seconds
           showConfirmButton: false,
         });
   
       } catch (error) {
         console.error('Error during form submission:', error);
         Swal.fire({
           icon: 'error',
           title: 'Error',
           text: 'Something went wrong while submitting the form!',
         });
       }
  };
  

    const openModal = (type, data = { id: '', sub_domain: subDomain, series: seriesValue || '', reviewer_id: '', reviewer_name: '', reviewer_affiliation: '', reviewer_country: '', uploadedfile: null, status: false, approval: false
    }) => {
      setErrors({}); // ✅ Clear previous errors
      setModalType(type);
      setForm(data);

      const statusBool = !!data.status;
      const approvalBool = !!data.approval;
    
      if (type === 'edit') {
        setOriginalStatus(statusBool); // store original status for comparison
      }
    
      setForm({
        ...data,
        status: statusBool,
        approval: approvalBool,
      });
    
      setShowModal(true);
    };

const handleSearchChange = (e) => {
    setSearchText(e.target.value);
};

const handlePageChange = (page) => {
    setCurrentPage(page);
};

//based country code append country name
  const getCountryName = (code) => {
  const country = countries.find(c => c.code === code);
  return country ? country.name : code;
  };
 
// Memoized filtered data based on search query
const filteredData = useMemo(() => {
    return dataList.filter(
    (data) =>
        data.sub_domain.toLowerCase().includes(searchText.toLowerCase()) ||
        data.reviewer_name.toLowerCase().includes(searchText.toLowerCase())
    ).sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)); // Descending by updatedAt
}, [dataList, searchText]);

const columns = [
    {
    name: '#',
    selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
    sortable: false,
    width: '80px',
    },
    {
    name: 'Name',
    selector: (row) => row.reviewer_name	,
    sortable: true,
    },
    {
    name: 'Country',
    selector: (row) => getCountryName(row.reviewer_country),
    sortable: true,
    },
    {
        name: 'Signature',
        selector: (row) => (
            <img
              src={row.reviewer_signature}
              width="100"
              alt={row.reviewer_affiliation}
            />
          ),
        sortable: false,
        },
        {
            name: 'Status',
            cell: (row) => (
              <span className={`badge ${Number(row.status) === 1 ? 'bg-success' : 'bg-danger'}`}>
                {Number(row.status) === 1 ? 'Active' : 'Inactive'}
              </span>
            ),
            sortable: true,
          },
          {
            name: 'Approval',
            cell: (row) => (
              <span className={`badge ${Number(row.approval) === 1 ? 'bg-success' : 'bg-danger'}`}>
                {Number(row.approval) === 1 ? 'Active' : 'Inactive'}
              </span>
            ),
            sortable: true,
          },
                 
        {
        name: 'Actions',
        cell: (row) => (
            <div>
            <Button className="me-2" variant="warning" size="sm" onClick={() => openModal('edit', row)} > Edit </Button>
            </div>
        ),
        },
];

return (
    <div className="d-flex">
    <Sidebar />
    <div className="main-content w-100">
      <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
            <Spinner /> {/* Centered Spinner */}
          </div>
          ) :(
          <div>
            <div className="container-fluid p-4">
            <div className="row">
                <div className="col-8">
                <p className='fs-4'>Receipt Generation / Abstract Receipt / Configurations / Reviewers</p>
                </div>
                <div className="col-4 text-end">
                <button className="btn btn-primary mb-3" onClick={() => openModal('add')}>
                    Add
                </button>
                </div>
            </div>

        <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 20, 50, 100, 200, 500]}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
            <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                onChange={handleSearchChange}
                />
            </div>
            }
        />

        {/* Modal for Add/Edit data */}
        <Modal show={showModal} backdrop="static" className='modal-lg' onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
            <Modal.Title>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Form>      
                <div className='row'>      
                <Form.Group className="col-md-3 mb-3">
                <Form.Label>Subdomain</Form.Label>
                <Form.Control type="text" name="sub_domain" value={form.sub_domain} onChange={handleChange} required  readOnly/>
                </Form.Group>
                <Form.Group className="col-md-3 mb-3">
                <Form.Label>Series</Form.Label>
                <Form.Control type="text" name="series" value={form.series} onChange={handleChange} required  readOnly/>
                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                <Form.Label>Country</Form.Label>
                <Form.Control className="form-select mb-3" as="select" name="reviewer_country" value={form.reviewer_country} onChange={handleChange} isInvalid={!!errors.reviewer_country}>
                    <option value="">Select</option>
                    {countries.map((countries) => (
                        <option key={countries.name} value={countries.code}>
                        {countries.name}
                        </option>
                    ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">  {errors.reviewer_country} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                <Form.Label>Reviewer Name</Form.Label>
                <Form.Control type="text" name="reviewer_name" value={form.reviewer_name} onChange={handleChange} isInvalid={!!errors.reviewer_name}/>
                <Form.Control.Feedback type="invalid">  {errors.reviewer_name} </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="col-md-6 mb-3">
                <Form.Label>Reviewer Affiliation</Form.Label>
                <Form.Control type="text" name="reviewer_affiliation" value={form.reviewer_affiliation} onChange={handleChange} isInvalid={!!errors.reviewer_affiliation}/>
                <Form.Control.Feedback type="invalid">  {errors.reviewer_affiliation} </Form.Control.Feedback>
                </Form.Group>
                {modalType === 'edit' &&(
                <Form.Group className="col-md-6 mb-3">
                    <Form.Label>Status</Form.Label>
                    <Form.Select
                    name="status"
                    value={form.status ? '1' : '0'}
                    onChange={handleChange}
                    >
                    <option>Select</option>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                    </Form.Select>
                </Form.Group>
                )}
                <Form.Group className="col-md-6 mb-3">
                    <Form.Label>
                    Reviewer Signature <small className="text-primary">(Dimension:300x100 | Size:15kb to 30kb) </small><br></br>
                    <small>(upload your signature in <b>black color only</b>)</small>
                    </Form.Label>
                    <Form.Control
                        type="file"
                        name="uploadedfile"
                        onChange={handleChange} isInvalid={!!errors.uploadedfile}
                    />
                <Form.Control.Feedback type="invalid">  {errors.uploadedfile} </Form.Control.Feedback>
                </Form.Group>                                         
                </div>  
            </Form>
            </Modal.Body>
            <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}> Cancel </Button>
            <Button variant="primary" onClick={handleSubmit}> {modalType === 'add' ? 'Add' : 'Save'} </Button>
            </Modal.Footer>
        </Modal>
        </div>
        <Footer />
        </div>
      )};
    </div>
    </div>
);
};

export default Abreviewers;